export const autoSizeOptionsForDataGrid = {
  includeHeaders: true,
  includeOutliers: true,
};

export const dateTimeFormat = {
  date: "DD-MMM-YYYY",
  time: "HH:mm:ss",
  timestamp: "DD-MMM-YYYY HH:mm",
};

export const dataFetchFrequency = {
  timeSinceAndLeft: 1000000,
  taskDashboard: 6000000,
};
